package ui.campaign.detailv2.widgets

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import api.AppBehavior
import api.CampaignType
import api.VisualRotaryMode
import compose.assets.Svg
import compose.assets.svg.*
import kotlinx.datetime.LocalDate
import ssoft.frontend.generated.resources.*
import tools.formatFromRes
import tools.rememberString
import tools.roundDecimals
import tools.stringRes
import ui.widget.Space
import ui.widget.TwoFieldText
import ui.widget.TwoFieldTextIcon
import kotlin.math.roundToLong
import kotlin.time.Duration


@Composable
fun CampaignInfoCardMain(
    type: CampaignType,
    name: String,
    dtStart: LocalDate,
    dtEnd: LocalDate,
    volume: Float,

    enableCompanyCommercial: Boolean,
    isCom: Boolean,
    isNCom: Boolean,

    countLocation: Int,
    countDevice: Int,
    countVisuals: Int,
    countApps: Int,
    appBehavior: Int,
    impressionsSum: Long,

    impDur: Duration,
    impCount: Int,
    impSpace: Float,

    slotDur: Duration,
    slotCount: Int,
    slotCountCompany: Int,

    visualRotaryMode: Int
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(
            containerColor = MaterialTheme.colorScheme.surfaceContainer
        )
    ) {
        Column(
            verticalArrangement = Arrangement.spacedBy(8.dp),
            modifier = Modifier.fillMaxWidth().padding(16.dp),
        ) {
            Text(
                text = name,
                style = MaterialTheme.typography.headlineLarge
            )
            HorizontalDivider()
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                Icon(Svg.Calendar, null)
                Text(text = dtStart.formatFromRes())
                Icon(Svg.Arrow_left_right, null)
                Text(text = dtEnd.formatFromRes())
                Space(8.dp)
                ((dtEnd.toEpochDays() - dtStart.toEpochDays()) + 1).also {
                    Text(
                        if (it > 1) Res.string.layer_top_detail_editor__summary_day_count_multiple.rememberString(it)
                        else Res.string.layer_top_detail_editor__summary_day_count_single.rememberString(it),
                        modifier = Modifier.weight(1F),
                        textAlign = TextAlign.End
                    )
                }

            }
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                Icon(Svg.Volume_high, null)
                Text(
                    text = Res.string.layer_top_detail_editor__summary_audio_label.rememberString(),
                    modifier = Modifier.weight(1F)
                )
                if (volume <= 0.001) Icon(Svg.Close, null)
                else Text(text = "${(volume * 100F).roundToLong()}%")
            }
            if (countApps > 0 && type == CampaignType.IMPRESSION) {
                Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    Icon(Svg.Controller, null)
                    Text(
                        text = Res.string.layer_top_detail_editor__apps_playback_setup_title.rememberString(),
                        modifier = Modifier.weight(1F)
                    )
                    Text(
                        text = AppBehavior[appBehavior].stringRes().rememberString(),

                        )
                }
            }

            if (enableCompanyCommercial) {
                HorizontalDivider()
                TwoFieldTextIcon(
                    label = Res.string.layer_top_detail_editor__summary_commercial.rememberString(),
                    icon = if (isCom) Svg.Check else Svg.Close
                )
                TwoFieldTextIcon(
                    label = Res.string.layer_top_detail_editor__summary_non_commercial.rememberString(),
                    icon = if (isNCom) Svg.Check else Svg.Close
                )
            }
            HorizontalDivider()
            Summary(
                type = type,
                isCom = isCom,
                countLocation = countLocation,
                countDevice = countDevice,
                countVisuals = countVisuals,
                impressionsSum = impressionsSum,

                impDur = impDur,
                impCount = impCount,
                impSpace = impSpace,

                slotDur = slotDur,
                slotCount = slotCount,
                slotCountCompany = slotCountCompany
            )
            if (VisualRotaryMode.NONE notMatch visualRotaryMode) {
                HorizontalDivider()
//                Text(Res.string.layer_top_detail_editor__dynamic_visual_rotary_title.rememberString())
                Row(
                    horizontalArrangement = Arrangement.spacedBy(8.dp),
                    modifier = Modifier.padding(horizontal = 8.dp)
                ) {
                    Icon(Svg.Shuffle_variant, null)
                    Text(
                        text = Res.string.layer_top_detail_editor__dynamic_visual_rotary_title.rememberString(),
                        modifier = Modifier.fillMaxWidth().padding(horizontal = 8.dp)
                    )
                }
                TwoFieldTextIcon(
                    label = Res.string.layer_top_detail_editor__dynamic_visual_rotary_dynamic.rememberString(),
                    icon = if (VisualRotaryMode.DYNAMIC_VISUALS match visualRotaryMode) Svg.Check else Svg.Close
                )
                TwoFieldTextIcon(
                    label = Res.string.layer_top_detail_editor__dynamic_visual_rotary_primary.rememberString(),
                    icon = if (VisualRotaryMode.PRIMARY_VISUALS match visualRotaryMode) Svg.Check else Svg.Close
                )
            }
        }
    }
}


@Composable
private fun Summary(
    type: CampaignType,
    isCom: Boolean,
    countLocation: Int,
    countDevice: Int,
    countVisuals: Int,
    impressionsSum: Long,

    impDur: Duration,
    impCount: Int,
    impSpace: Float,

    slotDur: Duration,
    slotCount: Int,
    slotCountCompany: Int
) {

    TwoFieldText(
        label = Res.string.layer_top_detail_editor__summary_count_locations.rememberString(),
        message = countLocation,
        messageSuffix = "x"
    )
    TwoFieldText(
        label = Res.string.layer_top_detail_editor__summary_count_devices.rememberString(),
        message = countDevice,
        messageSuffix = "x"
    )
    TwoFieldText(
        label = Res.string.layer_top_detail_editor__summary_count_visuals.rememberString(),
        message = countVisuals,
        messageSuffix = "x"
    )
    if (isCom) {
        HorizontalDivider()
        when (type) {
            CampaignType.IMPRESSION -> SummaryImpressions(
                impDur = impDur,
                impCount = impCount,
                impSpace = impSpace,
            )

            CampaignType.SLOT -> SummarySlots(
                slotDur = slotDur,
                slotCount = slotCount,
                slotCountCompany = slotCountCompany
            )

            CampaignType.NONE -> Unit
        }
        HorizontalDivider()
        TwoFieldText(
            label = Res.string.layer_top_detail_editor__summary_count_impression_exp.rememberString(),
            message = (impressionsSum.toDouble() * 0.95).roundToLong(),
            messageSuffix = "x"
        )
        TwoFieldText(
            label = Res.string.layer_top_detail_editor__summary_count_impression_max.rememberString(),
            message = impressionsSum,
            messageSuffix = "x"
        )
    }
}

@Composable
private fun SummaryImpressions(
    impDur: Duration,
    impCount: Int,
    impSpace: Float,
) {
    TwoFieldText(
        label = Res.string.layer_top_detail_editor__summary_imp_dur.rememberString(),
        message = impDur
    )
    TwoFieldText(
        label = Res.string.layer_top_detail_editor__summary_imp_count.rememberString(),
        message = impCount,
        messageSuffix = "x"
    )
    TwoFieldText(
        label = Res.string.layer_top_detail_editor__summary_imp_pct.rememberString(),
        message = impSpace.roundDecimals(2),
        messageSuffix = "%"
    )
}

@Composable
private fun SummarySlots(
    slotDur: Duration,
    slotCount: Int,
    slotCountCompany: Int
) {
    TwoFieldText(
        label = Res.string.layer_top_detail_editor__summary_slot_dur.rememberString(),
        message = slotDur
    )
    TwoFieldText(
        label = Res.string.layer_top_detail_editor__summary_slot_count.rememberString(),
        message = "$slotCount / $slotCountCompany"
    )
}